import Clarity from '@microsoft/clarity';

export const useInitClarity = () => {
  const projectId = process.env.REACT_APP_MICROSOFT_CLARITY_PROJECT_ID;

  if (projectId) {
    Clarity.init(projectId);
  } else {
    console.warn('Microsoft Clarity project ID is missing.');
  }
};
